import { render, staticRenderFns } from "./diode-user-select.vue?vue&type=template&id=87a26138&scoped=true&"
import script from "./diode-user-select.vue?vue&type=script&lang=js&"
export * from "./diode-user-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a26138",
  null
  
)

export default component.exports